import { render, staticRenderFns } from "./EditProgram.vue?vue&type=template&id=52e1945a"
import script from "./EditProgram.vue?vue&type=script&lang=ts"
export * from "./EditProgram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports